import { Injectable } from '@angular/core';
import {map, flatMap, find, distinctUntilChanged, switchMap} from 'rxjs/operators';
import { OverviewBoard } from 'app/models/overview-board/overview-board.model';
import {BehaviorSubject, combineLatest, Observable} from 'rxjs';
import { OverviewBoardGQL, OverviewBoardParkGQL, OverviewBoardCustomPortfolioGQL } from '../graphql';
import {NavigationDetails} from '../navigation/navigation.service';

@Injectable()
export class OverviewBoardService {

  constructor(
    private overviewBoardGQL: OverviewBoardGQL,
    private overviewBoardParkGQL: OverviewBoardParkGQL,
    private overviewBoardCustomPortfolioGQL: OverviewBoardCustomPortfolioGQL
  ) { }

  public getOverviewBoardDataCustomPortfolio(navigationDetails: NavigationDetails): Observable<OverviewBoard[]> {
    return this.overviewBoardCustomPortfolioGQL.subscribe({
      variables: {
      portfolioId: navigationDetails.selectedPortfolioId, parkIds: navigationDetails.selectedParksIds}
    }).pipe(
      map(result => result.data?.portfolios[0].parks.map(park => OverviewBoard.mapFromPark(park, result.data?.portfolios[0].groupedResults.alarmsGroupedByPark)))
    )
  }
  public getOverviewBoardData(): Observable<OverviewBoard[]> {
    return this.overviewBoardGQL.subscribe().pipe(
      map(result => result.data.parks.map(park => OverviewBoard.mapFromPark(park)))
    );
  }

  public getOverviewBoardDataPark(name?, code?): Observable<OverviewBoard> {
    return this.overviewBoardParkGQL.subscribe({variables: {parkCode: code}}).pipe(map(result => OverviewBoard.mapFromPark(result.data.parks[0])));
  }

}
